// Edit these to personalise the pitch deck.
export const PITCH = {
  founder_name: "Billy Hadlow",
  company_legal: "Curb Crew (Pty) Ltd",
  contact_email: "billy@hadlowinnovations.co.za",
  contact_phone: "082 336 7929",
  city: "South Africa",
  the_ask: "Seeking R[X] in seed capital for first 1,000 cards and distribution into 3 priority cities (Johannesburg, Durban, Cape Town).",
  date: new Date().toLocaleDateString("en-ZA", { month: "long", year: "numeric" }),
};
